import React from 'react';

const LassoIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16pt" height="16pt" viewBox="0 0 64 64" className="svg-icon lasso-icon" {...props}>
        <ellipse
            ry="19.661016"
            rx="31.322035"
            cy="26.440678"
            cx="32.271187"
            id="path3356"
            style={{stroke: 'none', fill: '#b3b3b3'}}/>
        <path
            style={{fill: '#000000'}}
            d="M32.271 6.085c-17.645 0-32 9.196-32 20.5 0 7.923 7.058 14.806 17.353 18.217-2.022.867-3.353 2.442-3.353 4.283 0 2.804 3.075 5 7 5 1.458 0 2.8-.305 3.91-.83.432.395 1.09 1.247 1.09 2.83 0 1.84-.857 1.989-1 2v2c1.038 0 3-.836 3-4 0-1.952-.729-3.212-1.409-3.966.884-.837 1.41-1.883 1.41-3.034 0-.805-.26-1.557-.716-2.225a49.61 49.61 0 0 0 4.715.225c17.645 0 32-9.196 32-20.5s-14.355-20.5-32-20.5zm-16 43c0-1.626 2.29-3 5-3s5 1.374 5 3-2.29 3-5 3-5-1.374-5-3zm16-4c-16.542 0-30-8.3-30-18.5 0-10.201 13.458-18.5 30-18.5s30 8.299 30 18.5c0 10.2-13.458 18.5-30 18.5z"/>
    </svg>
);

export default LassoIcon;



// WEBPACK FOOTER //
// ./src/components/LassoIcon.js